import React, { useEffect, useRef, useState } from "react";
import { observer } from "mobx-react";
import { WalletStore } from "../../stores/wallet/wallet-store";
import { FONT_COLOR, FONT_VARIANT } from "../../../../components/fonts/font-props";
import "./threshold-trigger.scss";
import Currency from "../../../../components/currency/currency";
import FontBody2 from "../../../../components/fonts/font-body2/font-body2";

interface Props {
    walletStore: WalletStore;
}

const ThresholdTrigger: React.FC<Props> = observer(({walletStore} :Props) => {
    const statusBarRef = useRef<HTMLDivElement>(null);
    const triggerRef = useRef<HTMLDivElement>(null);
    const [statusBarWidth, setStatusBarWidth] = useState(0);
    const [triggerWidth, setTriggerWidth] = useState(0);

    useEffect(() => {
        setStatusBarWidth(statusBarRef.current?.offsetWidth || 0);
        setTriggerWidth(triggerRef.current?.offsetWidth || 0);
    }, []);
    
    const threshold = walletStore.rechargeThreshold;
    const maxPoint = walletStore.walletStatusBarMaximumPoint;

    if (threshold === null || maxPoint === null) {
        return null;
    }

    const percentOffset = (threshold / maxPoint) * 100;
    let triangleLeft = (percentOffset * statusBarWidth) / 100;
    let labelLeft = triangleLeft - triggerWidth / 2;

    triangleLeft = Math.max(3, Math.min(triangleLeft, statusBarWidth - 3));
    labelLeft = Math.max(0, Math.min(labelLeft, statusBarWidth - triggerWidth));

    return (
        <div className="wallet-status-bar-threshold-trigger" ref={statusBarRef}>
            <div
                className="wallet-status-bar-threshold-triangle"
                style={{ left: `calc(${triangleLeft}px - 3px)` }}
            />
            <div
                className="wallet-status-bar-threshold-label"
                ref={triggerRef}
                style={{ left: `${labelLeft}px` }}
            >
                <FontBody2 color={FONT_COLOR.PRIMARY2}>
                    Recharge trigger:{" "}
                    <FontBody2 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        <Currency amount={threshold} currencyCode={walletStore.walletCurrencyCode!} />
                    </FontBody2>
                </FontBody2>
            </div>
        </div>
    );
});

export default ThresholdTrigger;